import React from 'react';
import { BUTTON__CONTENT_CLASS } from "../constants";
export var ButtonInner = function ButtonInner(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: BUTTON__CONTENT_CLASS
  }, children);
};